import React, { ReactElement } from 'react';
import { Card, Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';

interface IDashboardStatisticCard {
    cardName: string;
    icon: ReactElement;
    baseColor: string;
    items: {
        name: string;
        value: string | number;
    }[];
    total: number;
    styleCard?: string;
}

export function DashboardStatisticCard({
    cardName,
    icon,
    baseColor,
    items,
    total,
    styleCard = '',
}: IDashboardStatisticCard) {
    return (
        <div className="col-xl-4 col-md-6 col-sm-12">
            <Card className={`shadow-sm border-0 ${styleCard}`}>
                <Card.Body className="p-3">
                    <div className="d-flex justify-content-between align-items-start">
                        <div>
                            <div className="text-uppercase">{cardName}</div>
                            <div className="h6 fw-bold">{total ?? 0}</div>
                        </div>
                        <div
                            className={`d-flex align-items-center justify-content-center rounded-circle bg-${baseColor} text-white`}
                            style={{ width: '40px', height: '40px' }}
                        >
                            {icon}
                        </div>
                    </div>

                    <Row className="gx-2 gy-1 small text-muted">
                        {items?.map((item, index) => (
                            <Col key={index} xs={12} sm={6}>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id={'dash'}>
                                            {item.name}: {item.value}
                                        </Tooltip>
                                    }
                                >
                                    <div className="text-truncate" style={{ maxWidth: '100%' }}>
                                        <strong>{item.name}:</strong> {item.value}
                                    </div>
                                </OverlayTrigger>
                            </Col>
                        ))}
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
}
